import Vue from "vue";
import locale from "element-ui/lib/locale";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import {
  InfiniteScroll,
  Loading,
  Message,
  MessageBox,
  Notification,
  Avatar,
  Badge,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Empty,
  Form,
  FormItem,
  Image,
  Input,
  Menu,
  MenuItem,
  Option,
  Pagination,
  Popover,
  Progress,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Skeleton,
  SkeletonItem,
  Statistic,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Upload,
} from "element-ui";

const components = [
  Avatar,
  Badge,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Empty,
  Form,
  FormItem,
  Image,
  Input,
  Menu,
  MenuItem,
  Option,
  Pagination,
  Popover,
  Progress,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Skeleton,
  SkeletonItem,
  Statistic,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Upload,
];

/**
 * Element UI 按需注册（样式由 babel-plugin-component 按组件注入）
 */
export function setupElementUI(elementLocale) {
  if (elementLocale) {
    locale.use(elementLocale);
  }
  Vue.component(CollapseTransition.name, CollapseTransition);

  components.forEach((c) => Vue.use(c));

  Vue.use(InfiniteScroll);
  Vue.use(Loading.directive);

  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$message = Message;
  Vue.prototype.$notify = Notification;
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
}
